<template>
  <div class="custom-main custom-theme chat-application" style="margin: 0px;">
    <a-layout class="ant-layout-body">
      <gpws-header/>
      <a-layout-content>
        <a-row>
          <a-col :xxl="2" :xl="2" :lg="2" :md="0" :sm="0" :xs="0">&nbsp;</a-col>
          <a-col :xxl="20" :xl="20" :lg="20" :md="24" :sm="24" :xs="24">
            <div v-if="trtc">
              <vue-drag-resize :w="800" :h="450" :minw="400" :minh="225" :x="drag.left" :y="drag.top" :z="99999"
                               :draggable="true" @resizing="resize" :style="{'border':'#91d5ff solid 1px'}">
                <div style="position:absolute;display: flex;flex-direction: row;width: 100%;height: 100%">
                  <div :style="{'width': drag.canvasWidth+'%'}">

                    <div
                        :style="{'position':'absolute','width': drag.canvasWidth+'%','margin-top': '0px','text-align': 'right','height': '32px','padding-right':'2px', 'z-index': '999', 'background-color': '#F5F5F5' }">

                      <a-button type="primary" @click="screenAction"
                                style="height: 24px;color:white;border: none;margin-top: 4px; margin-right: 30px">截图
                      </a-button>
                      <a-button v-if="drag.imgShow" type="primary" @click="hideScreenAction"
                                style="height: 24px;color:white;border: none;margin-top: 4px; margin-right: 30px">隐藏截图
                      </a-button>
                      <a-button v-if="!drag.imgShow && drag.imgs.length>0" type="primary" @click="showScreenAction"
                                style="height: 24px;color:white;border: none;margin-top: 4px; margin-right: 30px">显示截图
                      </a-button>
                      <a-button icon="poweroff" title="结束视频" size="large" @click="leaveTRTC"
                                style="width: 24px;height: 24px;background: #e7eff3;color:#fe6e6e;margin-right:10px;border: none;"/>
                    </div>
                    <div id="localStream" class="room-video-bg-img"
                         :style="{'z-index':'999','right': drag.imageRight+'px','bottom':'3px','position':'absolute','width': (drag.vw*0.3) + 'px','height':  (drag.vh*0.3) + 'px'}">
                    </div>
                    <div id="remoteStream" class="room-video-bg-img"
                         :style="{'width': drag.vw + 'px','height': drag.vh + 'px'}">
                    </div>
                    <a-button v-if="selfVideoPlay" icon="close" title="结束视频" size="large" @click="colseSelfVideo"
                              :style="{'z-index':'1000','position':'absolute','right': drag.imageRight+'px','bottom': '5px', 'width': '24px','height': '24px','background': '#e7eff3','color':'#fe6e6e','margin-right':'10px','border': 'none'}"/>
                    <a-button v-if="!selfVideoPlay" icon="video-camera" title="播放视频" size="large"
                              @click="startSelfVideo"
                              :style="{'z-index':'1000','position':'absolute','right': drag.imageRight+'px','bottom': '5px', 'width': '24px','height': '24px','background': '#e7eff3','color':'#fe6e6e','margin-right':'10px','border': 'none'}"/>
                  </div>
                  <div
                      :style="{'width': drag.imageWidth+'%', 'float':'right','height':'100%', 'max-height':'100%','overflow-y':'scroll'}">
                    <div v-for="item in drag.imgs" style="position: relative;padding-bottom:4px">
                      <a-button icon="close" title="删除截图" size="large" @click="removeScreen(item.path)"
                                style="position:absolute;right:1px;top:6px;width: 24px;height: 24px;background: #e7eff3;color:#fe6e6e;margin-right:10px;border: none;"/>
                      <img :src="item.url" style="width: 100%">

                    </div>

                  </div>
                </div>

              </vue-drag-resize>
            </div>
            <a-spin :spinning="loading" :tip="loadTip">
              <a-row>
                <a-col :xxl="16" :xl="16" :lg="16" :md="24" :sm="24" :xs="24" style="background-color: red">
                  <a-card size="small"
                          :head-style="{'borderBottom':'none', 'background':'rgba(236, 243, 246, 0.8)', 'paddingLeft':'24px', 'paddingRight':'24px'}"
                          :body-style="{'padding':'0px', 'paddingLeft':'24px', 'paddingRight':'24px'}">
                                        <span slot="title" class="gpws-model-title"
                                              style="font-size: 19px;color: rgba(26, 133, 180, 0.9);">
                                            <a-row>
                                                <a-col span="12">
                                                    <img src="../../../assets/img/split.png"
                                                         style="line-height:21px;margin-right: 9px;user-select: none;"/>辅诊信息
                                                </a-col>
                                                <a-col span="12">
                                                    <img src="../../../assets/img/end.png" style="float: right;line-height:21px;margin-right: 9px; cursor:pointer;user-select: none;" @click="endAction"/>
                                                    <img src="../../../assets/img/v-m.png" style="float: right;line-height:21px;margin-right: 9px; cursor:pointer;user-select: none;" @click="archiveDrawer()"/>
                                                    <img src="../../../assets/img/v-d.png" style="float: right;line-height:21px;margin-right: 9px; cursor:pointer;user-select: none;" @click="detailAction"/>
                                                </a-col>
                                            </a-row>
                                        </span>
                    <a-card size="small" :bordered="false"
                            :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}"
                            :body-style="{'padding':'0px', 'paddingLeft':'24px', 'paddingRight':'24px'}">
                                          <span slot="title" class="gpws-menu-title"
                                                style="font-size: 16px;font-family: Alibaba PuHuiTi;">
                                            <img src="../../../assets/img/peoples.png"
                                                 style="width:22px;height: 18px; margin-right: 9px;user-select: none;"/>辅诊关联方
                                          </span>
                      <a-row style="margin-bottom: 10px;">
                        <a-col span="6">
                          <div style="color: #6A6A6A; display: flex;flex-direction: row;align-items: center"><img src="../../../assets/img/times.png"
                                                           style="width:16px;height: 16px;user-select: none;"/>预约时间</div>
                          <div style="color:#1F1F1F; font-weight: 400">{{ record.visitDate }}&nbsp;{{ record.startTime }}-{{ record.endTime }}</div>
                        </a-col>
                        <a-col span="18">
                          <div style="color: #6A6A6A; display: flex;flex-direction: row;align-items: center"><img src="../../../assets/img/times.png"
                                                           style="width:16px;height: 16px;user-select: none;"/>申请时间</div>
                          <div style="color:#1F1F1F; font-weight: 400">{{ record.applyTime }}</div>
                        </a-col>
                      </a-row>
                      <a-row style="margin-bottom: 12px;">
                        <a-col span="6">
                          <div style="width: 200px;height: 70px;background: #F5F5E7;border-radius: 8px;">
                            <a-col span="8" style="padding: 5px 8px;">
                              <a-avatar style="background-color: rgb(135, 208, 104);" :size="56" icon="user"/>
                            </a-col>
                            <a-col span="16">
                              <div
                                  style="line-height:20px;font-size: 13px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #606060;">
                                发起方
                              </div>
                              <div
                                  style="line-height:25px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                                {{ record.doctor }}&nbsp;<span style="font-size: 14px;">{{ record.department }}</span>
                              </div>
                              <div
                                  style="line-height:25px;font-size: 14px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                                {{ record.organ }}
                              </div>
                            </a-col>
                          </div>
                        </a-col>
                        <a-col span="18">
                          <div
                              style="width: 200px;height: 70px;background: rgba(226, 239, 255, 0.86);border-radius: 8px;">
                            <a-col span="8"  style="padding: 5px 8px;">
                              <a-avatar :size="56" :src="doctorAvater"/>
                            </a-col>
                            <a-col span="16">
                              <div
                                  style="line-height:20px;font-size: 13px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #606060;">
                                受邀方
                              </div>
                              <div
                                  style="line-height:25px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                                {{ record.expert }}&nbsp;<span style="font-size: 14px;">{{ record.expertDepart }}</span>
                              </div>
                              <div
                                  style="line-height:25px;font-size: 14px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                                {{ record.expertOrgan }}
                              </div>
                            </a-col>
                          </div>
                        </a-col>
                      </a-row>
                    </a-card>
                    <a-card size="small" :bordered="false"
                            :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}"
                            :body-style="{'padding':'0px', 'paddingLeft':'24px', 'paddingRight':'24px'}">
                                          <span slot="title" class="gpws-menu-title"
                                                style="font-size: 16px;font-family: Alibaba PuHuiTi;">
                                            <img src="../../../assets/img/people.png"
                                                 style="width:14px;height: 18px;margin-right: 9px;user-select: none;"/>患者信息
                                          </span>
                      <a-row style="margin-bottom: 12px;">
                        <a-col span="6">
                          <div style="width: 200px;height: 70px;background: #F5F5E7;border-radius: 8px; display: flex;flex-direction: row;align-items: center">
                            <a-col span="8" style="text-align: center;padding: 5px 8px">
                              <a-avatar style="background-color: #e8e8e8;" :size="56" icon="user"/>
                            </a-col>
                            <a-col span="16" style="display: flex;flex-direction: column; justify-content: center; align-items: flex-start">
                              <div
                                  style="line-height:20px;font-size: 13px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #606060;">
                                患者
                              </div>
                              <div
                                  style="line-height:30px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">
                                {{ record.name }}
                              </div>
                            </a-col>
                          </div>
                        </a-col>
                        <a-col span="18">
                          <a-row style="line-height: 25px;color:#999999">
                            <a-col span="5">性别:<span style="font-weight: 300;color:#222222">{{record.sexName}}</span></a-col>
                            <a-col span="5">年龄:<span style="font-weight: 300;color:#222222">{{record.age}}</span></a-col>
                            <a-col span="5">孕否:<span style="font-weight: 300;color:#222222">{{record.gestate?'是':'否'}}</span></a-col>
                            <a-col span="9">联系电话:<span style="font-weight: 300;color:#222222">{{record.phone}}</span></a-col>

                          </a-row>
                          <a-row style="line-height: 25px;color:#999999">
                            <a-col span="12">初步诊断:<span style="color:#222222">{{record.diagnostic}}</span></a-col>
                            <a-col span="12">过敏史:<span style="color:#222222">{{ ((undefined != record.medical && null != record.medical)?(record.medical.allergyHistory||''):'') }}</span></a-col>
                          </a-row>
                        </a-col>
                      </a-row>
                    </a-card>
                    <a-card size="small" :bordered="false"
                            :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}"
                            :body-style="{'padding':'0px', 'paddingLeft':'24px', 'paddingRight':'24px'}">
                                          <span slot="title" class="gpws-menu-title"
                                                style="font-size: 16px;font-family: Alibaba PuHuiTi;">
                                            <img src="../../../assets/img/diagnose.png"
                                                 style="width:18px;height: 20px;margin-right: 9px;user-select: none;"/>辅诊开方
                                          </span>
                      <a-form :form="form" layout="horizontal">
                        <a-row>
                          <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                            <a-form-item :colon="false" label="临床诊断" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                              <a-select mode="multiple" :disabled="(diseased != undefined && !diseased)" v-decorator="['diseases', {rules: [{ required: false, message: '临床诊断必须填写!' }] }]"
                                        show-search :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                                        :not-found-content="null" @focus="handleDiseaseFocus" @deselect="handleDiseaseCancel" @select="handleDiseaseSelect"
                                        @search="(value) => handleDiseaseSearch(value)" placeholder="请输入疾病名称检索">
                                <a-select-option v-for="item in init.diseases" :key="item.id" :value="item.id">
                                  {{ item.name }}
                                </a-select-option>
                              </a-select>
                            </a-form-item>
                          </a-col>
                          <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                            <a-form-item :colon="false" label="中医主症" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                              <a-select show-search :disabled="(diseased != undefined && diseased)" v-decorator="['symptom', {rules: [{ required: false, message: '中医主症必须填写!' }], initialValue: (record.symptom||undefined) }]" placeholder="请输入中医主症后进行选择" :dropdown-style="{'width': '600px'}" option-label-prop="label" :dropdown-match-select-width="false" :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"  @select="mainSymptomSelect" @search="mainSymptomSearch">
                                <a-select-option value="" label="">选择中医主症</a-select-option>
                                <a-select-option v-for="item in init.symptoms" :key="item.id" :value="item.id" :label="item.name">
                                  <a-row>
                                    <a-col span="8" style="color:rgba(44, 158, 21, 1);font-weight: 400;">
                                      {{ item.name }}
                                    </a-col>
                                    <a-col span="16" style="white-space:pre-wrap;word-wrap:break-word;overflow:hidden;">
                                      <template v-if="(undefined != item.alias && null != item.alias && item.alias.length > 0)">
                                        <template v-for="e in item.alias">
                                          &nbsp;{{ e }}
                                        </template>
                                      </template>
                                      &nbsp;{{ item.initial }} &nbsp; {{ item.full }}
                                    </a-col>
                                  </a-row>
                                </a-select-option>
                              </a-select>
                            </a-form-item>
                          </a-col>
                          <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
                            <a-form-item :colon="false" label="中医辨证" class="gpws-m-b-10"
                                         :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                              <a-select mode="tags"
                                        v-decorator="['syndromes', {rules: [{ required: false, message: '中医辨证必须填写!' }] }]"
                                        placeholder="请填写中医辨证">
                                <a-select-option v-for="(e , i) in init.syndromes" :value="e" :key="'s-'+(i+1)">{{ e }}</a-select-option>
                              </a-select>
                            </a-form-item>
                          </a-col>
                        </a-row>
                        <a-row>
                          <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                            <a-form-item :colon="false" label="治疗建议" class="gpws-m-b-10"
                                         :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                                         :wrapper-col="{sm: 24, md: 12, lg: 22, xl: 22, xxl: 22 }">
                              <a-input
                                  v-decorator="['suggest', {rules: [{ required: false }], initialValue: '' }]"
                                  placeholder="请输入治疗建议"/>
                            </a-form-item>
                          </a-col>
                        </a-row>
                        <a-row>
                          <a-col span="12" style="padding-left: 30px;margin-bottom: 4px;">
                            <a-button-group shape="round">
                              <a-button size="default"
                                        :class="(init.recipeType == 'CM'?'gpws-recipe-left-active':'gpws-recipe-left-btn')"
                                        @click="recipeChange('CM')">中药处方
                              </a-button>
                              <a-button size="default"
                                        :class="(init.recipeType =='CPM'?'gpws-recipe-active':'gpws-recipe-btn')"
                                        @click="recipeChange('CPM')">中成药处方
                              </a-button>
                              <a-button size="default"
                                        :class="(init.recipeType =='WM'?'gpws-recipe-right-active':'gpws-recipe-right-btn')"
                                        @click="recipeChange('WM')">西药处方
                              </a-button>
                            </a-button-group>
                          </a-col>
                          <a-col span="12" style="padding-right: 30px;">
                            <a-button type="primary" style="float: right;" ghost
                                      @click="appendRecipeDrug">添加药品
                            </a-button>
                          </a-col>
                        </a-row>
                        <a-row>
                          <a-col>
                            <a-card :bordered="false" size="small"
                                    :style="{'paddingLeft':'0px','paddingRight':'0px','display':(init.recipeType == 'CM'?'block':'none')}"
                                    :head-style="{'borderBottom':'none'}"
                                    :body-style="{'padding':'0px'}">
                              <a-table :columns="column.cm" :data-source="cmrecipes"
                                       row-key="id" size="small" :scroll="{ y: 200 }" :rowClassName="getRowClass"
                                       :pagination="false" class="gpws-recipe-table">
                                                                <span slot="cmindex" slot-scope="text, record, index">
                                                                  {{ (index + 1) }}
                                                                </span>
                                <span slot="cmdrug" slot-scope="text, record, index">
                                                                  <a-auto-complete placeholder="请输入药品名称检索"
                                                                                   :default-value="record.id"
                                                                                   option-label-prop="label"
                                                                                   @search="value => autoCompleteDrugSearch(value, record.id, index, 'CM')"
                                                                                   @select="value => autoCompleteDrugSelect(value, index, 'CM')"
                                                                                   style="width: 180px;"
                                                                                   :dropdown-match-select-width="false"
                                                                                   :dropdown-style="{'width': '400px'}">
                                                                    <template slot="dataSource">
                                                                      <a-select-option v-for="item in drugs"
                                                                                       :key="'cm-'+(index + 1)+'-'+item.id"
                                                                                       :label="item.name"
                                                                                       :value="item.id">
                                                                        <a-row>
                                                                          <a-col span="8">
                                                                            {{ item.name }}
                                                                          </a-col>
                                                                          <a-col span="4">
                                                                            {{ item.formName }}
                                                                          </a-col>
                                                                          <a-col span="12">
                                                                            {{ item.supplier }}
                                                                          </a-col>
                                                                        </a-row>
                                                                      </a-select-option>
                                                                    </template>
                                                                  </a-auto-complete>
                                                                </span>
                                <span slot="cmform" slot-scope="text, record, index">
                                                                  {{ record.formName }}
                                                                </span>
                                <span slot="cmdosage" slot-scope="text, record, index">
                                                                  <a-input-number :min="0" :step="0.1"
                                                                                  v-model="record.dosage"
                                                                                  placeholder="请输入用量"/>
                                                                </span>
                                <span slot="cmunit" slot-scope="text, record, index">
                                                                  <a-select v-model="record.unit" style="width: 100px;">
                                                                    <a-select-option v-for="(item, i) in record.units"
                                                                                     :key="'d-'+record.id+'-'+(i+1)"
                                                                                     :value="item.name">
                                                                      {{ item.name }}
                                                                    </a-select-option>
                                                                  </a-select>
                                                                </span>
                                <span slot="cmrecommend"
                                      slot-scope="text, record, index">
                                                                  {{ record.recommend }}
                                                                </span>
                                <span slot="cmusage" slot-scope="text, record, index">
                                                                  <a-input placeholder="请输入备注" v-model="record.usage"
                                                                           style="min-width:250px;width: 100%;"/>
                                                                </span>
                                <span slot="cmoperate" slot-scope="text, record, index">
                                                                  <a href="javascript:;"
                                                                     @click="()=>deleteDrugs(record.id, index, 'CM')">删除</a>
                                                                </span>
                              </a-table>
                              <a-row>
                                <a-col :xxl="4" :xl="4" :lg="4" :md="24" :sm="24"
                                       :xs="24">
                                  <a-form-item :colon="false" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <span slot="label" style="font-size: 16px;font-weight: bold;">付数</span>
                                    <a-input-number :min="1" :max="30" :step="1"
                                                    v-decorator="['doses', {rules: [{ required: true, message:'中药付数不可为空.' }], initialValue: 1 }]"
                                                    placeholder="请输入中药付数"/>
                                  </a-form-item>
                                </a-col>
                                <a-col :xxl="20" :xl="20" :lg="20" :md="24" :sm="24"
                                       :xs="24">
                                  <a-form-item :colon="false" label="服用方法" class="gpws-m-b-10"
                                               :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }"
                                               :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
                                    <a-input v-decorator="['cmusage', {rules: [{ required: false }], initialValue: '' }]" placeholder="请输入服用方法">
                                      <a-button type="link" size="small" slot="addonAfter" @click="medicalSelectAction">选择</a-button>
                                    </a-input>
                                  </a-form-item>
                                </a-col>
                              </a-row>
                              <a-row>
                                <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24"
                                       :xs="24">
                                  <a-form-item :colon="false" label="医嘱" class="gpws-m-b-0"
                                               :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }"
                                               :wrapper-col="{sm: 24, md: 12, lg: 22, xl: 22, xxl: 22 }">
                                    <a-textarea
                                        v-decorator="['cmadvice', {rules: [{ required: false }], initialValue: '' }]"
                                        placeholder="请输入医嘱"/>
                                  </a-form-item>
                                </a-col>
                              </a-row>
                            </a-card>
                            <a-card :bordered="false" size="small"
                                    :style="{'paddingLeft':'0px','paddingRight':'0px','display':(init.recipeType == 'CPM'?'block':'none')}"
                                    :head-style="{'borderBottom':'none'}"
                                    :body-style="{'padding':'0px'}">
                              <a-table :columns="column.cpm"
                                       :data-source="cpmrecipes" row-key="id"
                                       size="small" :scroll="{ y: 200 }" :rowClassName="getRowClass"
                                       :pagination="false" class="gpws-recipe-table">
                                                                <span slot="cpmindex" slot-scope="text, record, index">
                                                                  {{ (index + 1) }}
                                                                </span>
                                <span slot="cpmdrug" slot-scope="text, record, index">
                                                                  <a-auto-complete placeholder="请输入药品名称检索"
                                                                                   :default-value="record.id"
                                                                                   option-label-prop="label"
                                                                                   @search="value => autoCompleteDrugSearch(value, record.id, index, 'CPM')"
                                                                                   @select="value => autoCompleteDrugSelect(value, index, 'CPM')"
                                                                                   style="width: 140px;"
                                                                                   :dropdown-match-select-width="false"
                                                                                   :dropdown-style="{'width': '400px'}">
                                                                    <template slot="dataSource">
                                                                      <a-select-option v-for="item in drugs"
                                                                                       :key="'cpm-'+(index + 1)+'-'+item.id"
                                                                                       :label="item.name"
                                                                                       :value="item.id">
                                                                        <a-row>
                                                                          <a-col span="8">
                                                                            {{ item.name }}
                                                                          </a-col>
                                                                          <a-col span="4">
                                                                            {{ item.formName }}
                                                                          </a-col>
                                                                          <a-col span="12">
                                                                            {{ item.supplier }}
                                                                          </a-col>
                                                                        </a-row>
                                                                      </a-select-option>
                                                                    </template>
                                                                  </a-auto-complete>
                                                                </span>
                                <span slot="cpmspec" slot-scope="text, record, index">
                                                                  {{ record.formName }} {{ record.spec }}
                                                                </span>
                                <span slot="cpmdosage" slot-scope="text, record, index"
                                      style="white-space: nowrap;">
                                                                  <a-input-number :min="0" :step="0.1"
                                                                                  v-model="record.dosage"
                                                                                  placeholder="请输入用量"
                                                                                  style="width: 80px;"/>
                                                                  <a-select v-model="record.unit" style="width: 80px;">
                                                                    <a-select-option v-for="(item, i) in record.units"
                                                                                     :key="'d-'+record.id+'-'+(i+1)"
                                                                                     :value="item.name">
                                                                      {{ item.name }}
                                                                    </a-select-option>
                                                                  </a-select>
                                                                </span>
                                <span slot="cpmfrequency"
                                      slot-scope="text, record, index">
                                                                  <a-select v-model="record.frequency"
                                                                            style="width: 110px;">
                                                                    <a-select-option
                                                                        v-for="(item, i) in init.frequencies"
                                                                        :key="'d-'+record.code+'-'+(i+1)"
                                                                        :value="item.code">
                                                                      {{ item.desc }}
                                                                    </a-select-option>
                                                                  </a-select>
                                                                </span>
                                <span slot="cpmqty" slot-scope="text, record, index"
                                      style="white-space: nowrap;">
                                                                  <a-input-number :min="0" :step="0.1"
                                                                                  v-model="record.saleQty"
                                                                                  placeholder="请输入总量"
                                                                                  style="width: 80px;"/>
                                                                  <a-select v-model="record.saleUnit"
                                                                            style="width: 80px;">
                                                                    <a-select-option
                                                                        v-for="(item, i) in record.saleUnits"
                                                                        :key="'d-'+record.id+'-'+(i+1)"
                                                                        :value="item.name">
                                                                      {{ item.name }}
                                                                    </a-select-option>
                                                                  </a-select>
                                                                </span>
                                <span slot="cpmoperate"
                                      slot-scope="text, record, index">
                                                                  <a href="javascript:;"
                                                                     @click="()=>deleteDrugs(record.id, index, 'CPM')">删除</a>
                                                                </span>
                              </a-table>
                              <a-row>
                                <a-col :xxl="4" :xl="4" :lg="4" :md="24" :sm="24"
                                       :xs="24">
                                  <a-form-item :colon="false" class="gpws-m-b-10"
                                               :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                               :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                                                        <span slot="label"
                                                                              style="font-size: 16px;font-weight: bold;">用药天数</span>
                                    <a-input-number :min="1" :step="1"
                                                    v-decorator="['cpmdays', {rules: [{ required: true, message:'用药天数不可为空.' }], initialValue: 1 }]"
                                                    placeholder="请输入用药天数"/>
                                  </a-form-item>
                                </a-col>
                                <a-col :xxl="20" :xl="20" :lg="20" :md="24" :sm="24"
                                       :xs="24">
                                  <a-form-item :colon="false" label="服用方法" class="gpws-m-b-10"
                                               :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }"
                                               :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
                                    <a-input
                                        v-decorator="['cpmusage', {rules: [{ required: false }], initialValue: '' }]"
                                        placeholder="请输入服用方法"/>
                                  </a-form-item>
                                </a-col>
                              </a-row>
                              <a-row>
                                <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24"
                                       :xs="24">
                                  <a-form-item :colon="false" label="医嘱" class="gpws-m-b-0"
                                               :label-col="{sm: 24, md: 12, lg: 1, xl: 1, xxl: 1 }"
                                               :wrapper-col="{sm: 24, md: 12, lg: 23, xl: 23, xxl: 23 }">
                                    <a-textarea
                                        v-decorator="['cpmadvice', {rules: [{ required: false }], initialValue: '' }]"
                                        placeholder="请输入医嘱"/>
                                  </a-form-item>
                                </a-col>
                              </a-row>
                            </a-card>
                            <a-card :bordered="false" size="small"
                                    :style="{'paddingLeft':'0px','paddingRight':'0px','display':(init.recipeType == 'WM'?'block':'none')}"
                                    :head-style="{'borderBottom':'none'}"
                                    :body-style="{'padding':'0px'}">
                              <a-table :columns="column.wm" :data-source="wmrecipes"
                                       row-key="id" size="small" :scroll="{ y: 200 }" :rowClassName="getRowClass"
                                       :pagination="false" class="gpws-recipe-table">
                                                                <span slot="wmindex" slot-scope="text, record, index">
                                                                  {{ (index + 1) }}
                                                                </span>
                                <span slot="wmdrug" slot-scope="text, record, index">
                                                                  <a-auto-complete placeholder="请输入药品名称检索"
                                                                                   :default-value="record.id"
                                                                                   option-label-prop="label"
                                                                                   @search="value => autoCompleteDrugSearch(value, record.id, index, 'WM')"
                                                                                   @select="value => autoCompleteDrugSelect(value, index, 'WM')"
                                                                                   style="width: 140px;"
                                                                                   :dropdown-match-select-width="false"
                                                                                   :dropdown-style="{'width': '400px'}">
                                                                    <template slot="dataSource">
                                                                      <a-select-option v-for="item in drugs"
                                                                                       :key="'wm-'+(index + 1)+'-'+item.id"
                                                                                       :label="item.name"
                                                                                       :value="item.id">
                                                                        <a-row>
                                                                          <a-col span="8">
                                                                            {{ item.name }}
                                                                          </a-col>
                                                                          <a-col span="4">
                                                                            {{ item.formName }}
                                                                          </a-col>
                                                                          <a-col span="12">
                                                                            {{ item.supplier }}
                                                                          </a-col>
                                                                        </a-row>
                                                                      </a-select-option>
                                                                    </template>
                                                                  </a-auto-complete>
                                                                </span>
                                <span slot="wmspec" slot-scope="text, record, index">
                                                                  {{ record.formName }} {{ record.spec }}
                                                                </span>
                                <span slot="wmdosage" slot-scope="text, record, index"
                                      style="white-space: nowrap;">
                                                                  <a-input-number :min="0" :step="0.1"
                                                                                  v-model="record.dosage"
                                                                                  placeholder="请输入用量"
                                                                                  style="width: 80px;"/>
                                                                  <a-select v-model="record.unit" style="width: 80px;">
                                                                    <a-select-option v-for="(item, i) in record.units"
                                                                                     :key="'d-'+record.id+'-'+(i+1)"
                                                                                     :value="item.name">
                                                                      {{ item.name }}
                                                                    </a-select-option>
                                                                  </a-select>
                                                                </span>
                                <span slot="wmfrequency"
                                      slot-scope="text, record, index">
                                                                  <a-select v-model="record.frequency"
                                                                            style="width: 110px;">
                                                                    <a-select-option
                                                                        v-for="(item, i) in init.frequencies"
                                                                        :key="'d-'+record.code+'-'+(i+1)"
                                                                        :value="item.code">
                                                                     {{ item.desc }}
                                                                    </a-select-option>
                                                                  </a-select>
                                                                </span>
                                <span slot="wmqty" slot-scope="text, record, index"
                                      style="white-space: nowrap;">
                                                                  <a-input-number :min="0" :step="0.1"
                                                                                  v-model="record.saleQty"
                                                                                  placeholder="请输入总量"
                                                                                  style="width: 80px;"/>
                                                                  <a-select v-model="record.saleUnit"
                                                                            style="width: 80px;">
                                                                    <a-select-option
                                                                        v-for="(item, i) in record.saleUnits"
                                                                        :key="'d-'+record.id+'-'+(i+1)"
                                                                        :value="item.name">
                                                                      {{ item.name }}
                                                                    </a-select-option>
                                                                  </a-select>
                                                                </span>
                                <span slot="wmoperate" slot-scope="text, record, index">
                                                                  <a href="javascript:;"
                                                                     @click="()=>deleteDrugs(record.id, index, 'WM')">删除</a>
                                                                </span>
                              </a-table>
                              <a-row>
                                <a-col :xxl="4" :xl="4" :lg="4" :md="24" :sm="24"
                                       :xs="24">
                                  <a-form-item :colon="false" class="gpws-m-b-10"
                                               :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }"
                                               :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                                                        <span slot="label"
                                                                              style="font-size: 16px;font-weight: bold;">用药天数</span>
                                    <a-input-number :min="1" :step="1"
                                                    v-decorator="['wmdays', {rules: [{ required: true, message:'用药天数不可为空.' }], initialValue: 1 }]"
                                                    placeholder="请输入用药天数"/>
                                  </a-form-item>
                                </a-col>
                                <a-col :xxl="20" :xl="20" :lg="20" :md="24" :sm="24"
                                       :xs="24">
                                  <a-form-item :colon="false" label="服用方法" class="gpws-m-b-10"
                                               :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }"
                                               :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
                                    <a-input
                                        v-decorator="['wmusage', {rules: [{ required: false }], initialValue: '' }]"
                                        placeholder="请输入服用方法"/>
                                  </a-form-item>
                                </a-col>
                              </a-row>
                              <a-row>
                                <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24"
                                       :xs="24">
                                  <a-form-item :colon="false" label="医嘱" class="gpws-m-b-0"
                                               :label-col="{sm: 24, md: 12, lg: 1, xl: 1, xxl: 1 }"
                                               :wrapper-col="{sm: 24, md: 12, lg: 23, xl: 23, xxl: 23 }">
                                    <a-textarea
                                        v-decorator="['wmadvice', {rules: [{ required: false }], initialValue: '' }]"
                                        placeholder="请输入医嘱"/>
                                  </a-form-item>
                                </a-col>
                              </a-row>
                            </a-card>
                          </a-col>
                        </a-row>
                      </a-form>
                      <div class="gpws-visit-btn-container" style="text-align:center;">
                        <div>
                          <img src="../../../assets/img/visit.png" style="cursor: pointer;user-select: none;"
                               @click="telemedVisitAction"/>
                        </div>
                      </div>
                    </a-card>
                  </a-card>
                </a-col>
                <a-col :xxl="8" :xl="8" :lg="8" :md="24" :sm="24" :xs="24">
                  <a-card size="small" class="app-chat chat"
                          :head-style="{'borderBottom':'none', 'height' : '60px', 'background':'rgba(236, 243, 246, 0.8)', 'paddingLeft':'24px', 'paddingRight':'24px'}"
                          :body-style="{'padding':'0px', 'minHeight':'290px', 'paddingLeft':'0px', 'paddingRight':'0px'}">
                                        <span slot="title" class="gpws-model-title"
                                              style="font-size: 19px;color: rgba(26, 133, 180, 0.9);">
                                          <a-row>
                                              <a-col span="3">
                                                  <a-avatar style="background-color: rgb(135, 208, 104);" :size="46"
                                                            icon="user"/>
                                              </a-col>
                                              <a-col span="21">
                                                  <div
                                                      style="line-height:25px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #222222;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;"> {{ record.doctor }}&nbsp;<span
                                                      style="font-size: 14px;">{{ record.department }}</span> </div>
                                                  <div
                                                      style="line-height:20px;font-size: 13px;font-family: Alibaba PuHuiTi;font-weight: 300;color: #606060;">{{
                                                      record.organ
                                                    }}</div>
                                              </a-col>
                                          </a-row>
                                        </span>
                    <div class="chat-content" style="background-color: #FBFBFB;">
                      <div ref="chats" class="chat-area"
                           style="background-color: #FBFBFB;border:none;height: calc(100vh - 320px);" >
                        <div class="chats">
                          <div v-for="(chat, index) in chats" :key="'c-'+index"
                               :class="chat.sender == 'I'?'chat chat-right':'chat'">
                            <div class="chat-avatar">
                              <a class="avatar">
                                <a-avatar v-if="chat.sender == 'I'" :src="doctorAvater"/>
                                <a-avatar v-else style="background-color: rgb(135, 208, 104);" icon="user"/>
                              </a>
                            </div>
                            <div class="chat-body">
                              <div v-for="(m, i) in chat.messages" :key="'m-'+index+'-'+ i"
                                   :class="m.type=='audio'?'chat-audio':'chat-text'">
                                <p v-if="m.type=='text'">{{ m.message }}</p>
                                <p v-if="m.type=='image'" style="padding: .15rem .2rem .15rem .15rem;">
                                  <img :src="m.message"
                                       style="width:100%;height: auto;cursor: pointer; background-color: white;"
                                       @click="showFullImg(m.message)"/>
                                </p>
                                <a-audio v-if="m.type=='audio'" :src="m.message"></a-audio>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="border-radius: 4px;">
                      <div class="chat-tool" style="background:#ffffff;height: 34px;">
                                                <span style="padding-right: 20px;line-height: 34px;">
                                                  <a-upload accept="image/*" :show-upload-list="false"
                                                            :before-upload="beforeUpload"
                                                            :custom-request="handleImgUpload">
                                                    <a-button icon="file-image" title="发送图片"
                                                              style="margin-left:6px;width: 32px;height: 32px;color: #2196f3;border: none;"/>
                                                  </a-upload>
                                                  <a-button icon="audio" title="发送录音" @click="onAudioModalAction"
                                                            style="margin-left:6px;width: 32px;height: 32px;color: #2196f3;border: none;"/>
                                                  <a-button icon="video-camera" title="视频通话" @click="connectTRTC"
                                                            :disabled="trtc"
                                                            style="margin-left:6px;width: 32px;height: 32px;color: #2196f3;border: none;"/>
                                                </span>
                      </div>
                      <a-textarea v-model="message" :rows="5" style="border: #d9d9d9 solid 0px;" ref="send" placeholder="请在此输入"
                                  @keyup.ctrl.enter="sendMeg"></a-textarea>
                    </div>
                    <div style="text-align: center;margin-top:10px;">
                      <img src="../../../assets/img/send.png" style="cursor: pointer;user-select: none;"
                           @click="sendMeg"/>
                    </div>
                  </a-card>
                </a-col>
              </a-row>
            </a-spin>
            <a-modal :title="null" centered :visible="audio.visible" :footer="null" @cancel="audioCancelAction"
                     width="350">
              <a-spin :spinning="audio.loading" tip="正在发送录音信息,请稍候....">
                <a-row>
                  <a-col span="8">
                    <a-button type="primary" :disabled="audio.isrecorder" @click="startRecorder">开始录音</a-button>
                  </a-col>
                  <a-col span="8">
                    <a-button type="danger" :disabled="!audio.isrecorder" @click="stopRecorder">结束录音</a-button>
                  </a-col>
                  <a-col span="8" style="line-height: 32px;">录音时长:<span style="color: red;">{{ audio.duration }}</span>秒
                  </a-col>
                </a-row>
                <a-row>
                  <a-col span="24">
                    <canvas id="canvas" style="height: 100px;width: 300px;margin-top: 10px;"></canvas>
                  </a-col>
                </a-row>
              </a-spin>
            </a-modal>
          </a-col>
          <a-col :xxl="2" :xl="2" :lg="2" :md="0" :sm="0" :xs="0">&nbsp;</a-col>
        </a-row>
      </a-layout-content>
      <a-layout-footer style="padding: 0px!important;">
        <gpws-footer/>
      </a-layout-footer>
    </a-layout>
    <a-modal :centered="true" v-model="medical.visible" :mask-closable="false" title="服药方法" @ok="medicalSelectOk" @cancel="medicalSelectCancel" :body-style="{'padding-top':'0px'}">
      <a-form>
        <a-row>
          <a-col>
            <a-form-item :colon="false" class="gpws-m-b-10" label="服用时间" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
              <a-select v-model="medical.dosingTime">
                <a-select-option v-for="e in (init.medicals||[]).filter(m => m.type == 'DOSING_TIME')" :title="e.content" :value="e.content" :key="e.id">{{ e.content }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item :colon="false" class="gpws-m-b-10" label="用法" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
              <a-select v-model="medical.usage">
                <a-select-option value="">&nbsp;</a-select-option>
                <a-select-option v-for="e in (init.medicals||[]).filter(m => m.type == 'USAGE')" :title="e.content" :value="e.content" :key="e.id">{{ e.content }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item :colon="false" class="gpws-m-b-10" label="服用频次" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
              <a-select v-model="medical.frequency">
                <a-select-option value="">&nbsp;</a-select-option>
                <a-select-option v-for="e in (init.medicals||[]).filter(m => m.type == 'FREQUENCY')" :title="e.content" :value="e.content" :key="e.id">{{ e.content }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item :colon="false" class="gpws-m-b-10" label="忌口" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
              <a-select mode="multiple" v-model="medical.avoidFoods">
                <a-select-option v-for="e in (init.medicals||[]).filter(m => m.type == 'AVOID_FOOD')" :title="e.content" :value="e.content" :key="e.id">{{ e.content }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item :colon="false" class="gpws-m-b-10" label="注意事项" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
              <a-select mode="multiple" v-model="medical.natices">
                <a-select-option value="">&nbsp;</a-select-option>
                <a-select-option v-for="e in (init.medicals||[]).filter(m => m.type == 'DISEASE_NOTICE')" :title="e.content" :value="e.content" :key="e.id">{{ e.content }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item :colon="false" class="gpws-m-b-10" label="常用医嘱" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
              <a-select mode="multiple" v-model="medical.advices">
                <a-select-option value="">&nbsp;</a-select-option>
                <a-select-option v-for="e in (init.medicals||[]).filter(m => m.type == 'ADVICE')" :title="e.content" :value="e.content" :key="e.id">{{ e.content }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <outpatient-drawer ref="outpatientDrawer"/>
    <archive-drawer ref="archiveDrawer" @clickit="loadVisitRecipes"/>
  </div>
</template>

<script>
import Vue from 'vue'
import TRTC from 'trtc-js-sdk';
import global from '../../../api/global';
import Recorder from 'js-audio-recorder';
import lamejs from 'lamejs';
import GpwsHeader from '@/components/base/Header.vue';
import GpwsFooter from '@/components/base/Footer.vue';
import Audio from '@/components/base/Audio.vue';
import doctorAvater from '@/assets/img/doctor-avater.png';
import hevueImgPreview from 'hevue-img-preview';
import VueDragResize from 'vue-drag-resize';
import ArchiveDrawer from '@/components/telemed/ArchiveDrawer.vue';
import OutpatientDrawer from '@/components/outpatient/OutpatientDrawer.vue';

Vue.use(hevueImgPreview);
Vue.component('vue-drag-resize', VueDragResize);
export default {
  name: "ExpertTelemedRoom",
  components: {
    'a-audio': Audio, GpwsHeader, OutpatientDrawer, ArchiveDrawer, GpwsFooter
  },
  data() {
    return {
      loading: false,
      loadTip: '',
      timeHandler:undefined,
      diseased:undefined,
      doctorAvater: doctorAvater,
      record: {},
      current: {},//当前用户
      socket: null,// websocket
      heartHandler: null,//心跳
      trtcClient: null,//视频句柄
      localStream: null,//本地音视频流句柄
      remoteStream: null,//远程音视频流句柄
      trtc: false,//是否正在视频聊天
      audio: {
        visible: false,
        loading: false,
        duration: 0,
        isrecorder: false
      },
      recorder: null,
      drawId: null,
      canvas: null,
      ctx: null,
      form: this.$form.createForm(this),
      cmrecipes: [{id: '', name: '', dosage: '', unit: '', recommend: '', units: [], usage: ''}],//中医处方
      cpmrecipes: [],//中成药处方
      wmrecipes: [],//西药处方
      drugs: [],
      diseases: [],
      chats: [],
      message: '',
      image: '',
      init: {
        recipeType: 'CM',
        symptoms:[],
        syndromes: [],
        medicals:[],//医嘱模板
        diseases: [],
        frequencies:[]
      },
      column: {
        cm: [{title: '序号', key: 'cmindex', align: 'center', width: 60, scopedSlots: {customRender: 'cmindex'}},
          {title: '药名', key: 'cmdrug', align: 'center', width: 200, scopedSlots: {customRender: 'cmdrug'}},
          {title: '剂型', key: 'cmform', align: 'center', width: 80, scopedSlots: {customRender: 'cmform'}},
          {title: '用量', key: 'cmdosage', align: 'center', width: 100, scopedSlots: {customRender: 'cmdosage'}},
          {title: '单位', key: 'cmunit', align: 'center', width: 120, scopedSlots: {customRender: 'cmunit'}},
          {title: '常用剂量', key: 'cmrecommend', align: 'center', width: 120, scopedSlots: {customRender: 'cmrecommend'}},
          {title: '备注', key: 'cmusage', scopedSlots: {customRender: 'cmusage'}},
          {title: '操作', key: 'cmoperate', align: 'center', width: 80, scopedSlots: {customRender: 'cmoperate'}}],
        cpm: [{title: '序号', key: 'cpmindex', align: 'center', width: 60, scopedSlots: {customRender: 'cpmindex'}},
          {title: '药名', key: 'cpmdrug', align: 'center', width: 150, scopedSlots: {customRender: 'cpmdrug'}},
          {title: '剂型规格', key: 'cpmspec', align: 'center', width: 100, scopedSlots: {customRender: 'cpmspec'}},
          {title: '单次剂量', key: 'cpmdosage', align: 'center', width: 180, scopedSlots: {customRender: 'cpmdosage'}},
          {title: '频次', key: 'cpmfrequency', align: 'center', width: 120, scopedSlots: {customRender: 'cpmfrequency'}},
          {title: '总量', key: 'cpmqty', align: 'center', width: 180, scopedSlots: {customRender: 'cpmqty'}},
          {title: '操作', key: 'cpmoperate', align: 'center', width: 80, scopedSlots: {customRender: 'cpmoperate'}}],
        wm: [{title: '序号', key: 'wmindex', align: 'center', width: 60, scopedSlots: {customRender: 'wmindex'}},
          {title: '药名', key: 'wmdrug', align: 'center', width: 150, scopedSlots: {customRender: 'wmdrug'}},
          {title: '剂型规格', key: 'wmspec', align: 'center', width: 100, scopedSlots: {customRender: 'wmspec'}},
          {title: '单次剂量', key: 'wmdosage', align: 'center', width: 180, scopedSlots: {customRender: 'wmdosage'}},
          {title: '频次', key: 'wmfrequency', align: 'center', width: 120, scopedSlots: {customRender: 'wmfrequency'}},
          {title: '总量', key: 'wmqty', align: 'center', width: 180, scopedSlots: {customRender: 'wmqty'}},
          {title: '操作', key: 'wmoperate', align: 'center', width: 80, scopedSlots: {customRender: 'wmoperate'}}]
      },
      selfVideoPlay: false,
      drag: {
        width: 800,
        vw: 800,
        vh: 450,
        top: 60,
        left: 10,
        imgs: [],    //截图记录
        canvasWidth: 100, //摄像头区占比
        imageWidth: 0,   //图片区占比
        imageRight: 0,     //本人图像距离右侧距离
        imgShow: false, //截图记录是否显示
      },
      medical:{
        visible:false,
        dosingTime:'',
        usage:'',
        frequency:'',
        avoidFoods:[],
        natices:[],
        advices:[]
      },
    }
  },
  mounted() {
    const self = this;
    this.$store.commit('updateTopMenu', '205');
    let id = this.$route.query.id || '';
    this.current = JSON.parse(localStorage.getItem("curruser"));
    this.startTelemedAction(id);
    if(localStorage.getItem('frequencies')){
      this.init.frequencies = JSON.parse(localStorage.getItem("frequencies"));
    }else{
      this.getFrequencies(function (res){
        self.init.frequencies = res;
        localStorage.setItem("frequencies", JSON.stringify(res));
      });
    }
    window.setTimeout(this.socketInit(), 3000);//初始化Socket
  },
  destroyed() {
    console.info('辅诊页面实例注销...');
    this.leaveTRTC();
    this.destroyRecorder();
    window.setTimeout(this.closeSocket(), 2000);
  },
  methods: {
    archiveDrawer:function (){
      this.$refs.archiveDrawer.showArchiveDrawer(this.record.patientId, 'TELEMEDICINE', this.current.organId, 'EXPERT');
    },
    loadVisitRecipes:function (id) {
      const self = this;
      this.loading = true;
      this.loadTip='正在加载处方信息....';
      this.drugs=[];
      this.$axios.get('/api/clinic/local/outpatient/'+id).then(function (res) {
        self.loading=false;
        if (res.msg.flag == 0){
          if(undefined != res.biz && null != res.biz){
            if(undefined != res.biz.recipes && null != res.biz.recipes && res.biz.recipes.length > 0){
              res.biz.recipes.forEach(function (e) {
                if(e.type == 'CM'){
                  self.cmrecipes=[];
                  self.cmdrugs=[];
                  e.drugs.forEach(function (n) {
                    self.drugs.push(Object.assign(n));
                    self.cmrecipes.push(Object.assign(n));
                  });
                  self.form.setFieldsValue({'doses': (e.doses||1), 'cmusage':e.usage, 'cmadvice':e.advice});
                }
                if(e.type == 'CPM'){
                  e.drugs.forEach(function (n) {
                    self.drugs.push(Object.assign(n, {msgs:[], errored:false}));
                  });
                  self.cpmrecipes=e.drugs;
                  self.form.setFieldsValue({'cpmdays': (e.days||1), 'cpmusage':e.usage, 'cpmadvice':e.advice});
                }
                if(e.type == 'WM'){
                  e.drugs.forEach(function (n) {
                    self.drugs.push(Object.assign(n, {msgs:[], errored:false}));
                  });
                  self.wmrecipes=e.drugs;
                  self.form.setFieldsValue({'wmdays': (e.days||1), 'wmusage':e.usage, 'wmadvice':e.advice});
                }
                self.appendRecipeDrug();
              });
            }
          }
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function (res) {
        self.loading=false;
      });
    },
    medicalSelectAction:function (){
      const self = this;
      if(localStorage.getItem('medicals')){
        this.init.medicals = JSON.parse(localStorage.getItem("medicals"))||[];
      }else{
        this.$axios.get('/api/clinic/' + this.current.doctorId + '/medical/templates').then(function(res){
          if(res.msg.flag == 0 && null != res.biz){
            self.init.medicals =res.biz;
            localStorage.setItem("medicals", JSON.stringify(res.biz));
          }
        },function(){
        });
      }

      this.medical.visible = true;
    },
    //服药方式选择
    medicalSelectOk:function () {
      let usages=[];
      let advices=[];
      if((this.medical.dosingTime||'') != ''){
        usages.push(this.medical.dosingTime);
      }
      if((this.medical.usage||'') != ''){
        usages.push(this.medical.usage);
      }
      if((this.medical.frequency||'') != ''){
        usages.push(this.medical.frequency);
      }
      if((this.medical.avoidFoods||[]).length > 0){
        advices.push(this.medical.avoidFoods.join('、'));
      }
      if((this.medical.natices||[]) != ''){
        advices.push(this.medical.natices.join('、'));
      }
      if((this.medical.advices||[]) != ''){
        advices.push(this.medical.advices.join('、'));
      }
      this.form.setFieldsValue({'cmusage':usages.join(';')});
      this.form.setFieldsValue({'cmadvice':advices.join(';')});

      this.medicalSelectCancel();
    },
    medicalSelectCancel:function (){
      Object.assign(this.medical, { visible:false, dosingTime:'', usage:'', frequency:'', avoidFoods:[], natices:[], advices:[]});
    },
    mainSymptomSearch:function(value){
      if(undefined != this.timeHandler || null != this.timeHandler){
        window.clearTimeout(this.timeHandler);
      }
      this.timeHandler = window.setTimeout(this.symptomSearch, 1000, value);
    },
    symptomSearch:function (value) {
      const self = this;
      let sex = this.visit.form.getFieldValue('sex');
      let year = this.visit.form.getFieldValue('year');

      let months = ((year||0) * 12) + this.record.month;

      this.init.symptoms=[];
      if(undefined != value && null != value && '' != value && value.trim().length > 0){
        this.$axios.get('/api/clinic/position/symptoms', {params:{keyword:value, sex:sex, months:months, common:true}}).then(function (res) {
          self.init.symptoms =[];
          if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            res.biz.forEach(function(e){
              if(undefined != e.children && null != e.children && e.children.length > 0){
                e.children.forEach(function (m) {
                  self.init.symptoms.push(m);
                });
              }
            });
          }
        }, function (res) {
        });
      }
    },
    mainSymptomSelect:function (value) {
      const self = this;
      this.init.syndromes=[];
      if(undefined != value && null != value && '' != value){
        this.$axios.get('/api/clinic/symptom/' + value + '/syndromes').then(function (res) {
          res.biz.forEach(function(e){
            self.init.syndromes.push(e.value);
          });
        }, function (res) {
        });
        this.diseased = false;
      }else{
        this.diseased = undefined;
      }
    },
    telemedVisitAction: function () {
      const self = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          if (undefined != self.cmrecipes && null != self.cmrecipes && self.cmrecipes.length > 0) {
            self.cmrecipes = self.cmrecipes.filter(e => (undefined != e.id && null != e.id && '' != e.id));
          }
          if (undefined != self.cpmrecipes && null != self.cpmrecipes && self.cpmrecipes.length > 0) {
            self.cpmrecipes = self.cpmrecipes.filter(e => (undefined != e.id && null != e.id && '' != e.id));
          }
          if (undefined != self.wmrecipes && null != self.wmrecipes && self.wmrecipes.length > 0) {
            self.wmrecipes = self.wmrecipes.filter(e => (undefined != e.id && null != e.id && '' != e.id));
          }

          if ((undefined == self.cmrecipes || null == self.cmrecipes || self.cmrecipes.length < 1) &&
              (undefined == self.cpmrecipes || null == self.cpmrecipes || self.cpmrecipes.length < 1) &&
              (undefined == self.wmrecipes || null == self.wmrecipes || self.wmrecipes.length < 1)) {
            self.$message.error({content: '请先出具门诊处方信息.', duration: 1});
            self.cmrecipes = [{id: '', name: '', dosage: '', unit: '', recommend: '', units: [], usage: ''}];
            return;
          }
          //中医处方验证
          let recipes = [];
          if (undefined != self.cmrecipes && null != self.cmrecipes && self.cmrecipes.length > 0) {
            self.init.recipeType = 'CM';
            for (let i = 0; i < self.cmrecipes.length; i++) {
              if (undefined == self.cmrecipes[i].id || null == self.cmrecipes[i].id || '' == self.cmrecipes[i].id) {
                self.$message.error({content: '中医处方中空行请先删除.', duration: 1});
                return;
              }
              if (undefined == self.cmrecipes[i].dosage || null == self.cmrecipes[i].dosage || '' == self.cmrecipes[i].dosage) {
                self.$message.error({content: '中医处方中药品[' + self.cmrecipes[i].name + ']用量未设置.', duration: 1});
                return;
              }
              if (undefined == self.cmrecipes[i].unit || null == self.cmrecipes[i].unit || '' == self.cmrecipes[i].unit) {
                self.$message.error({content: '中医处方中药品[' + self.cmrecipes[i].name + ']用量单位未设置.', duration: 1});
                return;
              }
            }
            recipes.push({
              type: 'CM',
              doses: values.doses,
              usage: values.cmusage,
              advice: values.cmadvice,
              drugs: self.cmrecipes
            });
          }
          //中成药验证
          if (undefined != self.cpmrecipes && null != self.cpmrecipes && self.cpmrecipes.length > 0) {
            self.init.recipeType = 'CPM';
            for (let i = 0; i < self.cpmrecipes.length; i++) {
              if (undefined == self.cpmrecipes[i].id || null == self.cpmrecipes[i].id || '' == self.cpmrecipes[i].id) {
                self.$message.error({content: '中成药处方中空行请先删除.', duration: 1});
                return;
              }
              if (undefined == self.cpmrecipes[i].dosage || null == self.cpmrecipes[i].dosage || '' == self.cpmrecipes[i].dosage) {
                self.$message.error({content: '中成药处方中药品[' + self.cpmrecipes[i].name + ']单次剂量未设置.', duration: 1});
                return;
              }
              if (undefined == self.cpmrecipes[i].unit || null == self.cpmrecipes[i].unit || '' == self.cpmrecipes[i].unit) {
                self.$message.error({content: '中成药处方中药品[' + self.cpmrecipes[i].name + ']单次剂量单位未设置.', duration: 1});
                return;
              }
              if (undefined == self.cpmrecipes[i].frequency || null == self.cpmrecipes[i].frequency || '' == self.cpmrecipes[i].frequency) {
                self.$message.error({content: '中成药处方中药品[' + self.cpmrecipes[i].name + ']频次未设置.', duration: 1});
                return;
              }
              if (undefined == self.cpmrecipes[i].saleQty || null == self.cpmrecipes[i].saleQty || '' == self.cpmrecipes[i].saleQty) {
                self.$message.error({content: '中成药处方中药品[' + self.cpmrecipes[i].name + ']总量未设置.', duration: 1});
                return;
              }
              if (undefined == self.cpmrecipes[i].saleUnit || null == self.cpmrecipes[i].saleUnit || '' == self.cpmrecipes[i].saleUnit) {
                self.$message.error({content: '中成药处方中药品[' + self.cpmrecipes[i].name + ']总量单位未设置.', duration: 1});
                return;
              }
            }
            recipes.push({type: 'CPM', usage: values.cpmusage, advice: values.cpmadvice, drugs: self.cpmrecipes});
          }
          //西药验证
          if (undefined != self.wmrecipes && null != self.wmrecipes && self.wmrecipes.length > 0) {
            self.init.recipeType = 'WM';
            for (let i = 0; i < self.wmrecipes.length; i++) {
              if (undefined == self.wmrecipes[i].id || null == self.wmrecipes[i].id || '' == self.wmrecipes[i].id) {
                self.$message.error({content: '西药处方中空行请先删除.', duration: 1});
                return;
              }
              if (undefined == self.wmrecipes[i].dosage || null == self.wmrecipes[i].dosage || '' == self.wmrecipes[i].dosage) {
                self.$message.error({content: '西药处方中药品[' + self.wmrecipes[i].name + ']单次剂量未设置.', duration: 1});
                return;
              }
              if (undefined == self.wmrecipes[i].unit || null == self.wmrecipes[i].unit || '' == self.wmrecipes[i].unit) {
                self.$message.error({content: '西药处方中药品[' + self.wmrecipes[i].name + ']单次剂量单位未设置.', duration: 1});
                return;
              }
              if (undefined == self.wmrecipes[i].frequency || null == self.wmrecipes[i].frequency || '' == self.wmrecipes[i].frequency) {
                self.$message.error({content: '西药处方中药品[' + self.wmrecipes[i].name + ']频次未设置.', duration: 1});
                return;
              }
              if (undefined == self.wmrecipes[i].saleQty || null == self.wmrecipes[i].saleQty || '' == self.wmrecipes[i].saleQty) {
                self.$message.error({content: '西药处方中药品[' + self.wmrecipes[i].name + ']总量未设置.', duration: 1});
                return;
              }
              if (undefined == self.wmrecipes[i].saleUnit || null == self.wmrecipes[i].saleUnit || '' == self.wmrecipes[i].saleUnit) {
                self.$message.error({content: '西药处方中药品[' + self.wmrecipes[i].name + ']总量单位未设置.', duration: 1});
                return;
              }
            }
            recipes.push({type: 'WM', usage: values.wmusage, advice: values.wmadvice, drugs: self.wmrecipes});
          }

          let params = {
            id: ((undefined != self.record && null != self.record && undefined != self.record.id
                && null != self.record.id && '' != self.record.id) ? self.record.id : ''),
            recipes: recipes, diseases: values.diseases, symptom:values.symptom, syndromes: values.syndromes, suggest: values.suggest
          };

          self.loading = true;
          self.loadTip = '正在提交开方信息,请稍候...';
          self.$axios.post('/api/clinic/telemed/visit', params).then(function (res) {
            self.loading = false;
            if (res.msg.flag == 0) {
              self.$message.success({content: '辅诊开方保存成功.', duration: 2});
              self.socket.send(JSON.stringify({
                contentType: 'application/event',
                from: self.current.doctorId,
                to: self.record.doctorId,
                body: JSON.stringify({event: 'VISITED', payload: res.biz}),
                tid: self.current.tenantId,
                bizId: self.record.id
              }));
              self.endAction();
            } else {
              self.$message.error({content: res.msg.message, duration: 2});
            }
          }, function (res) {
            self.loading = false;
          });
        }
      });
    },
    detailAction: function () {
      this.$refs.outpatientDrawer.showAction(this.record.id);
    },
    endAction: function () {
      this.leaveTRTC();
      this.destroyRecorder();
      window.setTimeout(this.closeSocket(), 2000);
      this.$router.push({path: '/telemed'});
    },
    closeSocket:function (){
      console.info('开始关闭Socket.');
      if (undefined != this.socket && null != this.socket) {
        this.socket.close();
      }
    },
    startTelemedAction: function (id) {
      const self = this;
      this.$axios.post('/api/clinic/telemed/' + id + '/startvisit').then(function (res) {
        if (res.msg.flag == 0) {
          self.loadTelemedOutpatient(id);
        }
      }, function (res) {
      });
    },
    handleImgUpload: function (src) {
      if (undefined != this.image && null != this.image && '' != this.image) {
        let meet = {
          contentType: 'image/*', from: this.current.doctorId, nickname: this.current.name,
          to: this.record.doctorId, body: this.image, tid: this.current.tenantId, bizId: this.record.id
        };
        this.socket.send(JSON.stringify(meet));
        console.info("发送的消息内容：" + JSON.stringify(meet));
        //添加消息
        this.appendMsg(this.record.id, 'I', 'image', this.image);
        this.image = '';
      }
      return false;
    },
    beforeUpload: function (file) {
      if (undefined != file && null != file) {
        const isLt = file.size / 1024 / 1024 < 2;
        if (!isLt) {
          this.$message.error({content: '图片文件大小需少于2M.', duration: 2});
          return false;
        }
        this.getBase64(file);
      } else {
        this.$message.error({content: '请先选择需要上传的图片文件.', duration: 2});
        return false;
      }
      return true;
    },
    getBase64: function (file) {
      const self = this;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        self.image = reader.result;
      };
      reader.onerror = () => {
        self.image = '';
      }
    },
    loadTelemedOutpatient: function (id) {
      const self = this;
      this.loadTip = '正在获取远程辅诊信息,请稍候....';
      this.loading = true;

      this.$axios.get('/api/clinic/outpatient/' + id + '/medical').then(function (res) {
        self.loading = false;
        if (res.msg.flag == 0 && null != res.biz) {
          self.record = res.biz;
          self.loadChats(res.biz.id);
        }
      }, function (res) {
        self.loading = false;
      });
    },
    autoCompleteDrugSearch: function (value, id, index, type) {
      const self = this;
      this.drugs = [];
      this.cleanDrugRecipe(id, index, type);
      if (undefined != value && null != value && '' != value && value.trim().length > 0) {
        this.$axios.get('/api/clinic/drug/query', {
          params: {
            organId: this.record.organId,
            keyword: value,
            type: type,
            length: 20
          }
        }).then(function (res) {
          if (res.msg.flag == 0) {
            self.drugs = [];
            if (null != res.biz && !res.biz.empty) {
              res.biz.forEach(function (e) {
                self.drugs.push(Object.assign(e, {saleQty: 1}));
              });
            }
          }
        }, function (res) {
        });
      }
    },
    autoCompleteDrugSelect: function (value, index, type) {
      const self = this;
      this.drugs.forEach(function (e, i) {
        if (e.id == value) {
          if (type == 'CM') {
            self.cmrecipes.splice(index, 1, e);
          }
          if (type == 'CPM') {
            self.cpmrecipes.splice(index, 1, e);
          }
          if (type == 'WM') {
            self.wmrecipes.splice(index, 1, e);
          }
          self.appendRecipeDrug();
        }
      });
    },
    deleteDrugs: function (id, index, type) {
      if (this.init.recipeType == 'CM') {
        this.cmrecipes.splice(index, 1);
      }
      if (this.init.recipeType == 'CPM') {
        this.cpmrecipes.splice(index, 1);
      }
      if (this.init.recipeType == 'WM') {
        this.wmrecipes.splice(index, 1);
      }
    },
    cleanDrugRecipe: function (id, index, type) {
      if (type == 'CM') {
        this.cmrecipes.splice(index, 1, {id: '', name: '', dosage: '', unit: '', recommend: '', units: [], usage: ''});
      }
      if (type == 'CPM') {
        this.cpmrecipes.splice(index, 1, {
          id: '', name: '', dosage: '', form: '', spec: '', salePrice: '', unit: '',
          frequency: '', units: [], saleQty: 1, saleUnit: '', saleUnits: []
        });
      }
      if (type == 'WM') {
        this.wmrecipes.splice(index, 1, {
          id: '', name: '', dosage: '', form: '', spec: '', salePrice: '', unit: '',
          frequency: '', units: [], saleQty: 1, saleUnit: '', saleUnits: []
        });
      }
    },
    handleDiseaseFocus: function () {
      this.init.diseases = [];
    },
    handleDiseaseSelect: function (value) {
      const self = this;
      this.init.diseases.forEach(function (e, m) {
        if (e.id == value && self.diseases.filter(n => n.id == e.id).length <= 0) {
          self.diseases.push(e);
        }
      });
      this.diseased = true;
      this.loadSyndromes();
    },
    handleDiseaseCancel: function (value) {
      const self = this;
      let data = new Array();
      let deleteIndex = -1;
      Object.assign(data, this.diseases);
      this.diseases.forEach(function (e, m) {
        if (e.id == value) {
          deleteIndex = m;
        }
      });
      if (deleteIndex >= 0) {
        data.splice(deleteIndex, 1);
      }
      this.diseases = data;
      if((this.diseases||[]).length <= 0){
        this.diseased = undefined;
      }else{
        this.diseased = true;
      }
      this.loadSyndromes();
    },
    loadSyndromes: function () {
      const self = this;
      this.init.syndromes = [];

      this.diseases.forEach(function (e, i) {
        if (undefined != e.syndromes && null != e.syndromes && e.syndromes.length > 0) {
          e.syndromes.forEach(function (m, n) {
            if (self.init.syndromes.filter(a => a == m.name).length <= 0) {
              self.init.syndromes.push(m.name);
            }
          });
        }
      });
    },
    //疾病查询
    handleDiseaseSearch: function (value) {
      if(undefined != this.timeHandler || null != this.timeHandler){
        window.clearTimeout(this.timeHandler);
      }
      this.timeHandler = window.setTimeout(this.diseaseSearch, 1000, value);
    },
    diseaseSearch: function (value) {
      const self = this;
      this.init.diseases = [];

      if (undefined != value && null != value && '' != value && value.length > 1) {
        this.$axios.get('/api/clinic/diseases', {params: {keyword: value, sex:self.record.sex,
            year:self.record.year, month:self.record.month}}).then(function (res) {
          if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            self.init.diseases = res.biz;
          }
        }, function (res) {
        });
      }
    },
    recipeChange: function (key) {
      this.init.recipeType = key;
      this.drugs=[];
    },
    //添加药品
    appendRecipeDrug: function () {
      if (this.init.recipeType == 'CM') {
        if (this.cmrecipes.filter(e => (undefined == e.id || null == e.id || '' == e.id)).length <= 0) {
          this.cmrecipes.push({id: '', name: '', dosage: '', unit: '', recommend: '', units: [], usage: ''});
        }
      }
      if (this.init.recipeType == 'CPM') {
        if (this.cpmrecipes.filter(e => (undefined == e.id || null == e.id || '' == e.id)).length <= 0) {
          this.cpmrecipes.push({
            id: '', name: '', dosage: '', form: '', spec: '', salePrice: '', unit: '',
            frequency: '', units: [], saleQty: 1, saleUnit: '', saleUnits: []
          });
        }
      }
      if (this.init.recipeType == 'WM') {
        if (this.wmrecipes.filter(e => (undefined == e.id || null == e.id || '' == e.id)).length <= 0) {
          this.wmrecipes.push({
            id: '', name: '', dosage: '', form: '', spec: '', salePrice: '', unit: '',
            frequency: '', units: [], saleQty: 1, saleUnit: '', saleUnits: []
          });
        }
      }
    },
    destroyRecorder: function () {
      const self = this;
      if (this.recorder) {
        this.recorder.destroy().then(() => {
          self.recorder = null;
          self.drawId && cancelAnimationFrame(self.drawId);
          self.drawId = null;
        });
      }
    },
    socketInit: function () {
      const self = this;
      if (typeof (WebSocket) == 'undefined') {
        this.$message.error({content: '浏览器不支持WebSocket.', duration: 2});
      } else {
        if ('WebSocket' in window) {
          self.createSocket();
        } else {
          this.$message.error({content: '浏览器不支持WebSocket.', duration: 2});
        }
      }
    },
    createSocket:function (){
      const self = this;
      try {
        self.socket = new WebSocket(global.wsEUrl + '?uid=' + self.current.id);
        self.socket.onopen = function (event) {
          if (self.heartHandler) {
            window.clearTimeout(self.heartHandler);
          }
          self.heartHandler = window.setTimeout(self.heartbeat, 30000);
        };
        //接收消息监听
        self.socket.onmessage = function (event) {
          let data = event.data;
          console.log("接收到服务端数据：" + data);
          let msg = JSON.parse(data);

          if (msg.header.contentType == 'application/event') {
            if (undefined != msg.body && null != msg.body && '' != msg.body) {
              let body = JSON.parse(msg.body);
              //关闭视频事件
              if (body.event === 'CLOSE_VIDEO') {
                console.info('基层医生拒绝接受音视频.');
                self.closeVideoEvent('0');//对方关闭音视频事件处理
              }
            } else {
              console.log('WebSocket事件消息为空.');
            }
          } else {
            if (msg.bizId == self.record.id) {
              if (msg.header.contentType.startsWith('text')) {
                self.appendMsg(self.record.id, 'U', 'text', msg.body);
              }
              if (msg.header.contentType.startsWith('image')) {
                self.appendMsg(self.record.id, 'U', 'image', msg.body);
              }
              if (msg.header.contentType.startsWith('audio')) {
                self.appendMsg(self.record.id, 'U', 'audio', msg.body);
              }
            }
          }
        },
        //关闭事件监听
        this.socket.onclose = function (event) {
          self.reconnect();
        };
        //错误事件监听
        this.socket.onerror = function (event) {
          self.reconnect();
        };
      } catch (error) {
        console.log(error);
      }
    },
    //心跳检测
    heartbeat: function () {
      if (this.socket && this.socket.readyState == 1) {
        this.socket.send(JSON.stringify({
          contentType: 'application/pong',
          body: JSON.stringify({event: 'pong'}),
          to: 'system'
        }));
      }else{
        this.reconnect();
      }
      if (this.heartHandler) {
        window.clearTimeout(this.heartHandler);
      }
      this.heartHandler = window.setTimeout(this.heartbeat, 30000);
    },
    //重连函数
    reconnect: function () {
      if (this.socket && this.socket.readyState == 1) {
        return;
      }
      if (this.socket){
        console.log('WebSocket先关闭');
        this.socket.close();
      }
      console.log('WebSocket再重连');
      this.createSocket();
    },
    sendMeg: function () {
      if (undefined != this.message && null != this.message && '' != this.message) {
        let meet = {
          contentType: 'text/plain', from: this.current.doctorId, nickname: this.current.name,
          to: this.record.doctorId, body: this.message, tid: this.current.tenantId, bizId: this.record.id
        };
        this.socket.send(JSON.stringify(meet));
        console.info("发送的消息内容：" + JSON.stringify(meet));
        //添加消息
        this.appendMsg(this.record.id, 'I', 'text', this.message);
        this.message = '';
      }
      this.$refs.send.focus();
    },
    appendMsg: function (id, sender, type, body) {
      const self = this;
      if (undefined == this.chats || null == this.chats) {
        this.chats = [];
      }
      this.chats.push({sender: sender, messages: [{type: type, message: body}]});
      //调整滚动条
      let containerTimer = window.setTimeout(() => {
        self.$refs.chats.scrollTop = self.$refs.chats.scrollHeight;
        // 清理定时器
        window.clearTimeout(containerTimer);
      }, 10);
    },
    //音视频
    //连接音视频
    connectTRTC: function () {
      const self = this;
      if (undefined == this.record || null == this.record || undefined == this.record.id || null == this.record.id || '' == this.record.id) {
        this.$message.error({content: '请选择需要实时音视频的辅诊信息.', duration: 2});
        return;
      } else {
        this.trtc = true;
        this.$axios.get('/api/dmz/chat/room').then(function (res) {
          if (res.msg.flag == 0 && null != res.biz) {
            self.trtcClient = TRTC.createClient({
              mode: 'rtc', sdkAppId: self.current.videoAppId,
              userId: self.current.doctorId, userSig: self.current.userSig
            });
            self.trtcClient.on('stream-added', event => {
              const remoteStream = event.stream;
              //订阅远端流
              self.trtcClient.subscribe(remoteStream);
            });
            self.trtcClient.on('stream-subscribed', event => {
              const remoteStream = event.stream;
              self.remoteStream = remoteStream;
              // 播放远端流
              document.getElementById("remoteStream").innerHTML = '';
              remoteStream.play('remoteStream');
            });
            self.trtcClient.join({roomId: res.biz}).catch(error => {
              self.trtc = false;
              self.cleanStream();
              self.$message.error('实时音视频进房失败,原因:' + error);
            }).then(() => {
              self.localStream = TRTC.createStream({userId: self.current.doctorId, audio: true, video: true});
              self.localStream.initialize().then(() => {
                self.localStream.play('localStream');//播放本地流

                self.trtcClient.publish(self.localStream).then(() => {
                  setTimeout(function () {
                    self.socket.send(JSON.stringify({
                      contentType: 'application/event',
                      from: self.current.doctorId,
                      to: self.record.doctorId,
                      body: JSON.stringify({event: 'OPEN_VIDEO', payload: res.biz}),
                      tid: self.current.tenantId,
                      bizId: self.record.id
                    }));
                  }, 500)
                  self.selfVideoPlay = true;

                }).catch(error => {
                  self.selfVideoPlay = true;
                  self.trtc = false;
                  self.cleanStream();
                  console.error('本地音视频流发布失败:' + error);
                  self.$message.error('本地音视频流发布失败:' + error);
                });
              }).catch(error => {
                self.trtc = false;
                self.cleanStream();
                console.error('本地音视频初始化失败:' + error);
                if (error.name == 'NotAllowedError') {
                  self.$message.error('获取本地音视频设备权限失败.');
                } else {
                  self.$message.error('本地音视频初始化失败:' + error);
                }
              });
            });
          } else {
            self.cleanStream();
            self.trtc = false;
          }
        }, function (res) {
          self.cleanStream();
          self.trtc = false;
        });
      }
    },
    //退出视频房间
    leaveTRTC: function () {
      this.closeVideoEvent('1');//主动发起关闭
    },
    //退出视频房间
    closeVideoEvent: function (source) {
      const self = this;
      if (undefined != this.trtcClient && null != this.trtcClient) {
        // 取消发布本地流
        // 取消发布本地流
        console.info('开始取消发布本地流');
        this.trtcClient.unpublish(this.localStream).then(() => {
          console.info('取消发布本地流成功');
        });
        //关闭本地音视频
        if (undefined != this.localStream && null != this.localStream) {
          console.info('开始关闭本地摄像头');
          const videoTrack = this.localStream.getVideoTrack();
          if (videoTrack) {
            this.localStream.removeTrack(videoTrack).then(() => {
            });
            videoTrack.stop();
          }
          this.localStream.muteAudio();
        }
        //退出房间
        this.trtcClient.leave().then(() => {
          console.info('开始退出视频房间');
          if (source === '1') {
            self.socket.send(JSON.stringify({
              contentType: 'application/event',
              from: self.current.doctorId,
              to: self.record.doctorId,
              body: JSON.stringify({event: 'CLOSE_VIDEO', payload: self.record.id}),
              tid: self.current.tenantId,
              bizId: self.record.id
            }));
          }
          self.trtcClient = null;
          self.localStream = null;
          self.remoteStream = null;
          self.trtc = false;
        }).catch(error => {
          self.trtcClient = null;
          self.localStream = null;
          self.remoteStream = null;
          self.trtc = false;
        });
      } else {
        this.trtcClient = null;
        this.localStream = null;
        this.remoteStream = null;
        this.trtc = false;
      }
      this.cleanStream();
    },
    cleanStream: function () {
      if(document.getElementById('localStream')){
        document.getElementById('localStream').innerHTML = '';
      }
      if(document.getElementById('remoteStream')){
        document.getElementById('remoteStream').innerHTML = '';
      }
    },
    startRecorder: function () {
      const self = this;
      Recorder.getPermission().then(
          () => {
            if (undefined == self.recorder || null == self.recorder) {
              self.recorder = new Recorder({sampleBits: 16, sampleRate: 48000, numChannels: 1});
              self.recorder.onprogress = (params) => {
                self.audio.duration = params.duration.toFixed(0);
              }
            }
            self.recorder.start().then(() => {
              self.audio.isrecorder = true;
              self.canvas = document.getElementById('canvas');
              self.ctx = self.canvas.getContext('2d');
              self.drawCanvas();
            }, (error) => {
              self.$message.error(`${error.name} : ${error.message}`);
            });
          },
          (error) => {
            if (error.name == 'NotFoundError') {
              self.$message.error('请先接入麦克风.');
            }
            if (error.name == 'NotAllowedError') {
              self.$message.error('获取麦克风权限失败.');
            } else {
              self.$message.error(`${error.name} : ${error.message}`);
            }
          }
      );
    },
    stopRecorder: function () {
      const self = this;
      this.audio.loading = true;
      let mp3Blob = this.convertToMp3(this.recorder.getWAV());
      if (undefined != mp3Blob && null != mp3Blob) {
        let file = new File([mp3Blob], 'recorder.mp3');
        let params = new FormData();
        params.append("file", file);
        this.destroyRecorder();
        this.$axios.post('/api/dmz/CHAT/file/upload', params, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }, timeout: 1000 * 60 * 15
        }).then(function (res) {
          self.audio.loading = false;
          self.audio.isrecorder = false;
          if (res.msg.flag == 0) {
            let meet = {
              contentType: 'audio/*', from: self.current.doctorId, nickname: self.current.name,
              to: self.record.doctorId, body: res.biz.url, tid: self.current.tenantId, bizId: self.record.id
            };
            self.socket.send(JSON.stringify(meet));
            console.info("发送的消息内容：" + JSON.stringify(meet));
            //添加消息
            self.audioCancelAction();
            self.appendMsg(self.record.id, 'I', 'audio', res.biz.url);
          } else {
            self.$message.error({content: res.msg.message, duration: 2});
          }
        }, function () {
          self.audio.loading = false;
        });
      }
    },
    convertToMp3: function (wavDataView) {
      // 获取wav头信息
      const wav = lamejs.WavHeader.readHeader(wavDataView); // 此处其实可以不用去读wav头信息，毕竟有对应的config配置
      const {channels, sampleRate} = wav;
      const mp3enc = new lamejs.Mp3Encoder(channels, sampleRate, 128);
      // 获取左右通道数据
      const result = this.recorder.getChannelData()
      const buffer = [];

      const leftData = result.left && new Int16Array(result.left.buffer, 0, result.left.byteLength / 2);
      const rightData = result.right && new Int16Array(result.right.buffer, 0, result.right.byteLength / 2);
      const remaining = leftData.length + (rightData ? rightData.length : 0);

      const maxSamples = 1152;
      for (let i = 0; i < remaining; i += maxSamples) {
        const left = leftData.subarray(i, i + maxSamples);
        let right = null;
        let mp3buf = null;

        if (channels === 2) {
          right = rightData.subarray(i, i + maxSamples);
          mp3buf = mp3enc.encodeBuffer(left, right);
        } else {
          mp3buf = mp3enc.encodeBuffer(left);
        }

        if (mp3buf.length > 0) {
          buffer.push(mp3buf);
        }
      }

      const enc = mp3enc.flush();

      if (enc.length > 0) {
        buffer.push(enc);
      }

      return new Blob(buffer, {type: 'audio/mp3'});
    },
    drawCanvas: function () {
      this.drawId = requestAnimationFrame(this.drawCanvas);
      // 实时获取音频大小数据
      let datas = this.recorder.getRecordAnalyseData(),
          length = datas.length;

      // 填充背景色
      this.ctx.fillStyle = 'rgb(248, 248, 250)';
      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

      // 设定波形绘制颜色
      this.ctx.lineWidth = 2;
      this.ctx.strokeStyle = 'rgb(33, 150, 243)';

      this.ctx.beginPath();

      var sliceWidth = this.canvas.width * 1.0 / length, // 一个点占多少位置，共有bufferLength个点要绘制
          x = 0;          // 绘制点的x轴位置

      for (var i = 0; i < length; i++) {
        var v = datas[i] / 128.0;
        var y = v * this.canvas.height / 2;

        if (i === 0) {
          // 第一个点
          this.ctx.moveTo(x, y);
        } else {
          // 剩余的点
          this.ctx.lineTo(x, y);
        }
        // 依次平移，绘制所有点
        x += sliceWidth;
      }

      this.ctx.lineTo(this.canvas.width, this.canvas.height / 2);
      this.ctx.stroke();
    },
    audioCancelAction: function () {
      this.audio.isrecorder = false;
      this.audio.duration = 0;
      this.recorder = null;
      this.audio.visible = false;
    },
    onAudioModalAction: function () {
      this.audio.visible = true;
    },
    showFullImg: function (url) {
      this.$hevueImgPreview({
        url: url,
        mainBackground: 'rgba(0, 0, 0, .5)', // 整体背景颜色
      });
    },
    showBigImg: function (index) {
      this.$hevueImgPreview({
        multiple: true, // 开启多图预览模式
        nowImgIndex: index, // 多图预览，默认展示第二张图片
        imgList: this.images, // 需要预览的多图数组
        mainBackground: 'rgba(0, 0, 0, .5)', // 整体背景颜色
      });
    },
    //获取最后50条聊天记录
    loadChats: function (id) {
      const self = this;
      this.chats = [];
      this.$axios.get('/api/dmz/' + id + '/chats', {params: {size: 50}}).then(function (res) {
        if (res.msg.flag == 0 && null != res.biz && res.biz.length > 0) {
          res.biz.forEach(function (item, index) {
            if (undefined != item.from && null != item.from && '' != item.from) {
              let from = JSON.parse(item.from);
              if (from.uid === self.current.doctorId) {
                if (item.contentType.startsWith('text')) {
                  self.appendMsg(id, 'I', 'text', item.body);
                }
                if (item.contentType.startsWith('image')) {
                  self.appendMsg(id, 'I', 'image', item.body);
                }
                if (item.contentType.startsWith('audio')) {
                  self.appendMsg(id, 'I', 'audio', item.body);
                }
              } else {
                if (item.contentType.startsWith('text')) {
                  self.appendMsg(id, 'U', 'text', item.body);
                }
                if (item.contentType.startsWith('image')) {
                  self.appendMsg(id, 'U', 'image', item.body);
                }
                if (item.contentType.startsWith('audio')) {
                  self.appendMsg(id, 'U', 'audio', item.body);
                }
              }
            }
          });
        }
      }, function (res) {
      });
    },

    screenAction: function () {//对方视频截图
      let self = this;
      let frame = self.remoteStream.getVideoFrame();
      if (frame) {
        let params = new FormData();
        params.append("file", self.dataUrlToFile(frame));
        self.$axios.post('/api/clinic/telemed/' + self.record.id + '/screen/add', params, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }, timeout: 1000 * 60 * 15
        }).then(function (res) {

          if (res.msg.flag == 0) {
            self.drag.imgs.push(res.biz);
            self.drag.imageRight = self.drag.width * 0.2 + 3;
            self.drag.vw = self.drag.width * 0.8;
            self.drag.imgShow = true;
            self.drag.canvasWidth = 80;
            self.drag.imageWidth = 20;
          } else {
            self.$message.error({content: res.msg.message, duration: 2});
          }
        }, function () {
          //self.loading = false;
        });

      }

    },
    /**
     * 图片转文件
     */
    dataUrlToFile: function (src) {
      var arr = src.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      let filename = (new Date()).getTime() + '.png'
      return new File([u8arr], filename, {type: mime});
    },

    removeScreen: function (path) {
      let self = this;
      self.$axios.delete('/api/clinic/telemed/' + self.record.id + '/screen/remove', {params: {path: path}}).then(function (res) {
        if (res.msg.flag == 0) {
          let deleteIndex = -1;
          self.drag.imgs.forEach(function (item, index) {
            if (item.path == path) {
              deleteIndex = index;
            }
          });
          if (deleteIndex > -1) {
            self.drag.imgs.splice(deleteIndex, 1);
          }
          if (self.drag.imgs.length == 0) {
            self.hideScreenAction();
          }
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function () {
        //self.loading = false;
      });
    },

    hideScreenAction: function () {
      this.drag.imgShow = false;
      this.drag.vw = this.drag.width;
      this.drag.imageRight = 3;
      this.drag.canvasWidth = 100;
      this.drag.imageWidth = 0;

    },

    showScreenAction: function () {
      this.imgShow = true;
      this.drag.vw = this.drag.width * 0.8;
      this.drag.imageRight = this.drag.width * 0.2 + 3;
      this.drag.canvasWidth = 80;
      this.drag.imageWidth = 20;

    },
    /**
     * 关闭本地图像
     */
    colseSelfVideo: function () {
      let self = this;
      console.info(this.localStream)
      let videoTrack = this.localStream.getVideoTrack();
      if (videoTrack) {
        this.localStream.removeTrack(videoTrack)
        // 停止采集，关闭摄像头
        videoTrack.stop();
        self.selfVideoPlay = false;
      }
    },

    startSelfVideo: function () {
      let self = this;
      const videoStream = TRTC.createStream({userId: self.current.doctorId, audio: true, video: true});
      videoStream.initialize().then(function () {
        self.localStream.addTrack(videoStream.getVideoTrack());
        self.selfVideoPlay = true;
      });

    },

    resize: function (rect) {
      console.info(rect)
      console.info('resize=' + rect.width)
      let rate = this.drag.imgShow ? 0.8 : 1;
      this.drag.width = rect.width
      this.drag.vw = rect.width * rate;
      this.drag.imageRight = rect.width * (1 - rate) + 3;
      this.drag.vh = rect.height;
    },
    getRowClass:function(record,index){
      return index%2 == 0 ? 'single-row' : 'double-row'
    }
  }
}
</script>

<style scoped>
@import '../../../assets/css/chat.css';
@import '../../../assets/css/room.css';

.gpws-m-b-10 {
  margin-bottom: 10px !important;
}

.gpws-recipe-table {
  min-height: 250px !important;
  padding-top: 0px !important;
  padding-bottom: 12px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.gpws-recipe-left-active {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  border-top-left-radius: 18px !important;
  border-bottom-left-radius: 18px !important;
  color: white;
}

.gpws-recipe-right-active {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  border-top-right-radius: 18px !important;
  border-bottom-right-radius: 18px !important;
  color: white;
}

.gpws-recipe-left-btn {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  border-top-left-radius: 18px !important;
  border-bottom-left-radius: 18px !important;
}

.gpws-recipe-right-btn {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  border-top-right-radius: 18px !important;
  border-bottom-right-radius: 18px !important;
}

.gpws-recipe-active {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  color: white;
}

.gpws-visit-btn-container {
  padding: 10px 96px !important;
  background-color: #fff !important;
}

.gpws-recipe-btn {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
}
</style>
